/*
* Gift Card Lookup
* @param {object} opts
*/

import { createApp } from 'vue';
import GiftCardLookup from '../components/gift-card-lookup/GiftCardLookup';

function giftCardLookupApp(opts) {
  const config = {
    dom: {
      section: 'js-gift-card-lookup',
    },
  };

  const c = __.extend(config, opts);
  const $sections = document.querySelectorAll(`.${c.dom.section}`);

  function init() {
    if (!$sections?.length) return;

    [...$sections].forEach(($section) => {
      const $data = document.getElementById(`${$section.id}-data`);

      if (!$data) return;

      try {
        createApp(GiftCardLookup, { data: JSON.parse($data.textContent) }).mount($section);
      } catch (error) {
        console.error({ message: 'Error launching Gift Card Lookup', error });
      }
    });
  }

  return init();
}

export default giftCardLookupApp;
